<template>
    <div class="flex items-center justify-center text-center p-6 py-12">
      <div>
        
        <h1 class="text-8xl font-bold"> 🏗️ </h1>
        <h1 class="text-4xl font-bold text-gray-700 mb-4">Coming Soon</h1>
        <p class="text-lg text-gray-500">This page is under construction. Stay tuned!</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ComingSoon'
  }
  </script>